import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import OnboardingChatPage from '@/pages/OnboardingChatPage';

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/onboarding" replace /> },
  { path: '/onboarding', element: <OnboardingChatPage /> },
  { path: '*', element: <Navigate to="/onboarding" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
